export enum JsonType {
    TABLE = "table",
}
